import { render, staticRenderFns } from "./Allergyanamnesis.vue?vue&type=template&id=6c4c258a&lang=pug&"
import script from "./Allergyanamnesis.vue?vue&type=script&lang=js&"
export * from "./Allergyanamnesis.vue?vue&type=script&lang=js&"
import style0 from "./Allergyanamnesis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports